import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import { devConfig } from 'config/config'; // Import development configuration

/**
 * ConfigurationView class extends JetView to create a configuration interface.
 */
export default class configurationView extends JetView {
    /**
     * Defines the layout configuration for the view.
     * @returns {Object} The layout configuration object.
     */
    config() {
        const _ = this.app.getService('locale')._; // Get localization service
        return {
            type: 'wide', // Set layout type to wide
            cols: [
                {
                    localId: 'inner:layout', // Local ID for inner layout
                    type: 'wide', // Set inner layout type to wide
                    rows: [
                        {
                            view: 'tabbar', // Create a tab bar for navigation
                            localId: 'tabbar', // Local ID for tab bar
                            height: 43, // Set height of the tab bar
                            options: [
                                {
                                    id: 'customers.configuration.changePassword', // ID for change password tab
                                    value: _('Cambiar Contraseña'), // Localized value for the tab
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'customersConfigurationSecurityChangesPassword',
                                        'Menu',
                                    ),
                                    css: 'prm-customersConfigurationSecurityChangesPassword', // CSS class for styling
                                },
                                {
                                    id: 'customers.configuration.securityChanges', // ID for security changes tab
                                    value: _('Seguridad y Cambios'), // Localized value for the tab
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'customersConfigurationSecurityChangesMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-customersConfigurationSecurityChangesMenu', // CSS class for styling
                                },
                                {
                                    id: 'customers.configuration.securityChanges2', // ID for contingency tab
                                    value: _('Contingencia'), // Localized value for the tab
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'customersConfigurationSecurity2ChangesMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-customersConfigurationSecurity2ChangesMenu', // CSS class for styling
                                },
                                {
                                    id: 'customers.configuration.limitChanges', // ID for limits tab
                                    value: _('Limites'), // Localized value for the tab
                                    hidden: !devConfig.getPermAction(
                                        // Determine visibility based on permissions
                                        'customersConfigurationLimitChangesMenu',
                                        'Menu',
                                    ),
                                    css: 'prm-customersConfigurationLimitChangesMenu', // CSS class for styling
                                },
                            ],
                        },
                        { $subview: true }, // Placeholder for subview
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use Menu plugin with the tab bar
        this.on(
            this.app,
            'person:select',
            (
                person, // Listen for person selection event
            ) => this.setParam('user', person.id, true), // Set user parameter based on selected person
        );
    }
}

// FILE DOCUMENTED
